const openDockedSections = (state: AnyFixMe) =>
  state.sectionedPanel.openDockedSections;
const shouldShow = (state: AnyFixMe) => state.sectionedPanel.shouldShow;

export { openDockedSections, shouldShow };
